// src/pages/communication/schedule/ScheduleDetail.jsx
import React from "react";
import { format } from "date-fns";
import { scheduleApi } from "../../../api/schedules";

export default function ScheduleDetail({ item, onEdit, onDeleted }) {
  if (!item) return null;

  const dt = item.start
    ? format(new Date(item.start), "yyyy-MM-dd HH:mm")
    : "-";

  const scopeColor = {
    personal: "bg-green-100 text-green-700 border-green-300",
    company: "bg-red-100 text-red-700 border-red-300",
    project: "bg-blue-100 text-blue-700 border-blue-300",
  }[item.scope];

  const handleDelete = async () => {
    const ok = window.confirm("정말 삭제하시겠습니까?");
    if (!ok) return;
    await scheduleApi.remove(item.id);
    onDeleted?.();
  };

  return (
    <div className="space-y-6">

      {/* ============================
          HEADER
      ============================ */}
      <div>
        <div className="flex items-center gap-2 mb-1">
          <h3 className="text-xl font-semibold text-slate-900">
            {item.title}
          </h3>

          <span
            className={`px-2 py-0.5 text-xs rounded-full border ${scopeColor}`}
          >
            {item.scope === "personal"
              ? "개인"
              : item.scope === "company"
              ? "회사"
              : "프로젝트"}
          </span>
        </div>

        <div className="text-sm text-slate-500">
          일정 상세 정보
        </div>
      </div>

      {/* ============================
          INFO CARD
      ============================ */}
      <div className="rounded-xl border bg-white shadow-sm p-5 space-y-5">
        
        {/* 일시 */}
        <div>
          <div className="text-sm font-medium text-slate-600">일시</div>
          <div className="text-body mt-1">{dt}</div>
        </div>

        {/* 참여자 — personal 일정에서는 아예 숨김 */}
        {item.scope !== "personal" && (
          <div>
            <div className="text-sm font-medium text-slate-600">참여자</div>
            {item.participants?.length ? (
              <div className="flex gap-2 flex-wrap mt-2">
                {item.participants.map((p) => (
                  <span
                    key={p.id}
                    className="px-3 py-1 rounded-full bg-slate-100 text-sm text-slate-800"
                  >
                    {p.name} 
                  </span>
                ))}
              </div>
            ) : (
              <div className="text-slate-400 mt-1 text-sm">
                참여자가 없습니다.
              </div>
            )}
          </div>
        )}

        {/* 메모 */}
        <div>
          <div className="text-sm font-medium text-slate-600">메모</div>
          {item.memo ? (
            <div className="mt-2 whitespace-pre-wrap text-body">
              {item.memo}
            </div>
          ) : (
            <div className="text-slate-400 mt-1 text-sm">
              등록된 메모가 없습니다.
            </div>
          )}
        </div>
      </div>

      {/* ============================
          ACTION BUTTONS
      ============================ */}
      <div className="flex justify-end gap-2">
        <button className="btn-edit" onClick={() => onEdit(item)}>
          수정
        </button>

        <button className="btn-delete" onClick={handleDelete}>
          삭제
        </button>
      </div>
    </div>
  );
}
